import { createAction } from 'redux-actions';
import {
  saveCampaignParams,
  getCampaignParams,
} from '@minerva-analytics/pantheon';

export const start = createAction(`SAVE_CAMPAIGN_PARAMS_START`);
export const success = createAction(`SAVE_CAMPAIGN_PARAMS_SUCCESS`);

export const saveCampaignParamsRedux = (parsedURLParams) => (dispatch) => {
  dispatch(start());
  const paramsInStorage = getCampaignParams();
  const newParamsSaved = saveCampaignParams(parsedURLParams);
  dispatch(
    success({
      ...paramsInStorage,
      ...newParamsSaved,
    }),
  );
};

export default {
  saveCampaignParamsRedux,
};
